import { AxiosResponse } from 'axios';

import client from '../../lib/service/plan.service';
import {
  PlanDistribution,
  PlanDistributionsResponse,
  PlanDistributionResponse,
  PlanDistributionEdit,
  PlanDistributionData,
} from './plan-distribution.types';

const PLAN_DISTRIBUTIONS = 'v1/plan_distributions';
const PLAN_DISTRIBUTION = (id: number) => `${PLAN_DISTRIBUTIONS}/${id}`;

export const getPlanDistributions = async (): Promise<PlanDistribution[]> => {
  const response = await client.get<
    string,
    AxiosResponse<PlanDistributionsResponse>
  >(PLAN_DISTRIBUTIONS);

  return response.data.plan_distributions;
};

export const getPlanDistribution = async (
  id: number,
): Promise<PlanDistribution> => {
  const response = await client.get<PlanDistributionResponse>(
    PLAN_DISTRIBUTION(id),
  );

  return response.data.plan_distribution;
};

export const putPlanDistribution = async (
  data: PlanDistributionEdit,
): Promise<PlanDistribution> => {
  const { id, ...rest } = data;

  const response = await client.put<PlanDistributionResponse>(
    PLAN_DISTRIBUTION(id),
    { plan_distribution: rest },
  );

  return response.data.plan_distribution;
};

export const postPlanDistribution = async (
  data: PlanDistributionData,
): Promise<PlanDistribution> => {
  const response = await client.post<PlanDistributionResponse>(
    PLAN_DISTRIBUTIONS,
    { plan_distribution: data },
  );

  return response.data.plan_distribution;
};
